import React from "react";
import { useIntl } from "react-intl";

type Props = {
  description: string;
  className?: string;
};

const BadgeStatus: React.FC<Props> = ({ description, className }) => {
  const intl = useIntl();

  const statusMap = {
    pending: {
      color: "info",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.PENDING",
      })}`,
    },
    current: {
      color: "primary",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.CURRENT",
      })}`,
    },
    suspended: {
      color: "warning",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.SUSPENDED",
      })}`,
    },
    banned: {
      color: "danger",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.BANNED",
      })}`,
    },
    expired: {
      color: "danger",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.EXPIRED",
      })}`,
    },
    terminated: {
      color: "danger",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.TERMINATED",
      })}`,
    },
    void: {
      color: "dark",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.VOID",
      })}`,
    },
    available: {
      color: "success",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.AVAILABLE",
      })}`,
    },
    unavailable: {
      color: "danger",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.UNAVAILABLE",
      })}`,
    },
    approved: {
      color: "success",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.APPROVED",
      })}`,
    },
    opened: {
      color: "warning",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.OPENED",
      })}`,
    },
    in_process: {
      color: "primary",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.IN_PROCESS",
      })}`,
    },
    rejected: {
      color: "danger",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.REJECTED",
      })}`,
    },
    cancelled: {
      color: "secondary",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.CANCELLED",
      })}`,
    },
    refunded: {
      color: "primary",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.REFUNDED",
      })}`,
    },
    charged_back: {
      color: "warning",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.CHARGED_BACK",
      })}`,
    },
    in_mediation: {
      color: "warning",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.IN_MEDIATION",
      })}`,
    },
    authorized: {
      color: "primary",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.AUTHORIZED",
      })}`,
    },
    complianceUsers: {
      color: "success",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.COMPLIANCE_USERS",
      })}`,
    },
    nonComplianceUsers: {
      color: "danger",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.NON_COMPLIANCE_USERS",
      })}`,
    },
    bannedUsers: {
      color: "danger",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.BANNED_USERS",
      })}`,
    },
    usersOnline: {
      color: "success",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.USERS_ONLINE",
      })}`,
    },
    visitorsOnline: {
      color: "success",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.VISITORS_ONLINE",
      })}`,
    },
    allUsersOnline: {
      color: "success",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.USERS_ONLINE",
      })}`,
    },
    uncompliance: {
      color: "danger",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.UNCOMPLIANCE",
      })}`,
    },
    yes: {
      color: "danger",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.YES",
      })}`,
    },
    no: {
      color: "danger",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.NO",
      })}`,
    },
    overdue: {
      color: "danger",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.OVERDUE",
      })}`,
    },
    unoverdue: {
      color: "success",
      text: `${intl.formatMessage({
        id: "MODULE.STATUSBADGE.UNOVERDUE",
      })}`,
    },
  };

  const status = statusMap[description as keyof typeof statusMap] || {
    color: "light",
    text: "",
  };

  return (
    <span
      className={`badge badge-light-${status.color} ${className ?? ""}`}
      style={{ width: "fit-content" }}
    >
      {status.text}
    </span>
  );
};

export { BadgeStatus };
